class Gallery {
	constructor() {
		this.galleySwiper();
	}

	galleySwiper() {
		// Gallery swiper
		const gallerySwiper = new Swiper('.gallerySwiper', {
			slidesPerView: 'auto',
			spaceBetween: 20,
		});
	}
}
